export const DynamicToolTip = ({ text, children }) => {
  return (
    <span message={text}>
      <span className="msgId">{text}</span>
      {children}
    </span>
  );
};
